import theme from 'containers/app/theme'
import { GapCategory } from '../gapThresholds'

export const GAP_DETAILS: Record<GapCategory, { category: string; title: string; description: string; color: string }> = {
  High: {
    category: 'Niche',
    title: 'Niche (>50%)',
    description:
      'The target holds a commanding innovation lead. Competitor presence in the same technology space is weak, suggesting high strategic control. \n\nThis suggests the target may possess first mover advantage or category defining presence. A strong market signal to investors.',
    color: theme.palette.primary.main,
  },
  Moderate: {
    category: 'Specialised',
    title: 'Specialised (20–50%)',
    description:
      'The target maintains a strategic edge and is still clearly ahead.  Other firms are beginning to invest in similar areas and potential competition is building.\nThis reflects early-stage convergence or growing industry focus.',
    color: 'black',
  },
  Low: {
    category: 'Competitive',
    title: 'Competitive (0–20%)',
    description:
      'The target shares significant innovation space with peers. Strategic differentiation is minimal, and competitive pressure is high.\nSeveral competitors have strong overlap with the target’s innovation footprint. The target remains relevant, but its lead is narrow or eroding.',
    color: 'black',
  },
  Negative: {
    category: 'Crowded',
    title: 'Crowded (<0%)',
    description:
      'One or more competitors are more focused in this innovation space than the target itself. This may indicate loss of strategic direction or exposure to a better-positioned rival.',
    color: 'red',
  },
}
